<script setup lang="ts">
import type { GameVo } from '~/types/game'

interface Props {
  value: GameVo[]
}

defineProps<Props>()

const { toBlogSpecialDetail } = useRouterToPage()
const options = { hasReturnUrl: true, initQuery: true }
</script>

<template>
  <section>
    <LdSectionTitle>
      {{ $t('blog_page.blog_special') }}
    </LdSectionTitle>

    <div class="grid" grid-cols="2 md:4 xl:8" gap="y-20px x-24px md:x-40px">
      <template v-for="game in value" :key="game.gameId">
        <NuxtLink
          class="group flex items-center gap-x-12px gap-y-8px overflow-hidden"
          flex="row md:col"
          w="auto lg:109px"
          :to="toBlogSpecialDetail({ seo: game.seo || `${game.gameId}` }, options)"
        >
          <LdImage
            class="h-52px w-52px rd-12px md:h-109px md:w-109px md:rd-20px"
            transition="all-300"
            group-hover="scale-110"
            :src="game.icon" :alt="game.gameName"
          />
          <p class="line-clamp-2 flex-1 text-left text-14px c-dark-1 lh-20px t-300 md:w-full md:text-center group-hover:c-purple-1">
            {{ game.gameName }}
          </p>
        </NuxtLink>
      </template>
    </div>
  </section>
</template>

<style lang="scss" scoped>
</style>
